import React from "react";
import Header from "../../components/landingPage/Header";
import Footer from "../../components/landingPage/Footer";

const AboutUs = () => {
  return (
    <>
      <div>
        <Header className="static" />
        <div className="">
          <img
            src={require("../../assets/images/login_landing.jpg")}
            alt=""
            className="hidden sm:block sm:h-[70rem] md:h-[51rem] lg:h-[50rem] xl:h-[51rem] w-screen object-cover"
          />

          {/* ------------------------------------ FOR SCREEN BELOW 640px --------------------------------------- */}
          <div className="bg-black sm:transparent sm:hidden w-screen h-[60rem] object-cover"></div>
          {/* ------------------------------------ FOR SCREEN BELOW 640px --------------------------------------- */}

          <div className="bg-gradient-to-r from-[#121518] to-[#322d2d] w-full h-full sm:h-[70rem] md:h-[51rem] opacity-80 absolute top-0"></div>
          <div className="w-full absolute top-20">
            <div className="px-5 md:px-10 lg:px-44 xl:px-96 2xl:px-[25rem] text-left my-10 sm:my-16">
              <div className="bg-white rounded-lg p-6 sm:p-16 xl:p-10 opacity-80 shadow-md">
                <h2 className="text-4xl text-center text-primary">
                  Who <span className="text-secondary">Are We?</span>
                </h2>
                <div className="w-full mt-10">
                    <h2 className="text-xl text-slate-500">
                        Welcome to Drivado!
                    </h2>
                    <h3 className="text-slate-800 pt-5 text-justify">
                    Travel in one of our comfortable chauffeured vehicles
                    and experience the sophistication of elegant luxury
                    accompanied by impeccable service. You can book your
                    transfers globally online around the clock via the
                    website or the smartphone app. With just one click you
                    can get a binding price for the desired trip. With our
                    all-inclusive price we provide airport transfers,
                    station transfers, point to point transfers and hourly
                    disposals.
                    <br />
                    <br />
                    With us you get exactly the chauffeur service that best
                    suits your wishes and needs. Our vision is to offer a
                    smarter way to book and manage rides — something
                    affordable, reliable, and efficient.
                    <br />
                    <br />
                    Come, explore our services and book a transfer with us.
                    </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default AboutUs;
